export default __webpack_public_path__ + "static/media/BuffaloFries.8d7daea5.jpg";